import React from "react";

import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";

import ConversationList from "./ConversationList";
import UserAvatar from "./UserAvatar";
import Loader from "../Loader";
import NewConversationButton from "./NewConversationButton";
import NoConversations from "./NoConversations";
import SettingsButton from "./SettingsButton";

import { useAppSelector } from "../../hooks/reduxhook";
import { getConversations } from "../../redux/slices/conversationSlice";
import { getloadingforconversations } from "../../redux/slices/loadingSlice";

const drawerWidth = 290;

export default function LeftSidebar() {
  const conversations = useAppSelector(getConversations);
  const loading = useAppSelector(getloadingforconversations);
  return (
    <Drawer
      id="conversationlist"
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <NewConversationButton />
      <Divider />
      {loading && <Loader />}
      <Box
        sx={{
          overflow: "auto",
          flex: 1,
        }}
      >
        <div>
          {conversations?.length === 0 ? (
            <NoConversations />
          ) : (
            conversations?.map((conv) => (
              <ConversationList
                key={conv?.id}
                name={conv?.conv_name}
                conversation_id={conv?.id}
              />
            ))
          )}
        </div>
      </Box>
      <SettingsButton />
      <Divider />
      <UserAvatar />
    </Drawer>
  );
}
